import {createContext, ReactNode} from "react";
import type {ReviewAction} from "platformed-client/types";

/** A surface can show context under each reviewer, such as what changed since they approved. */
export const ReviewerNoteContext = createContext<((review: ReviewAction) => ReactNode) | null>(null);
